import api from './api';

export const defaulterrmsg = 'Something went wrong. Please try again.';

const session = () => {
  try {
    return JSON.parse(localStorage.getItem('authUserdetails') || 'null') || {};
  } catch (error) {
    return {};
  }
};

export const GetSecurityId = () => session().security_id;
export const GetOrgId = () => session().org_id;

export const getPaymentType = (value) => ({
  U: 'UPI',
  B: 'Bank',
  C: 'Cash',
  R: 'Credit',
  S: 'Scholarship',
})[value] || value;

export const AcademicYearOptions = async (orgId, duration) => {
  const { data } = await api.post('academic-years', {
    org_id: orgId,
    security_id: GetSecurityId(),
    academic_years_value: duration,
  });
  return (data || [])
    .slice()
    .sort((a, b) => Number(a.order ?? a.academic_year_value) - Number(b.order ?? b.academic_year_value))
    .map((item) => ({
      value: item._id,
      label: item.academic_year,
      order: item.order ?? item.academic_year_value,
    }));
};
